import { Quote } from "lucide-react";
import { Reveal, Overline, SectionTitle } from "./Reveal";

const QUOTES = [
  ["My mate and I finally run the same plan. Same workouts, our own weights, and I can see when he's skipped a session.", "Sam", "Trains with a buddy"],
  ["Logging takes seconds between exercises, and the weights go up when it's too easy. Seeing my numbers climb keeps me coming back.", "Mia", "Strength training"],
  ["Scanning food from the fridge and having calories worked out for me made sticking to my goal so much easier.", "Josh", "Losing weight"],
];

export const Testimonials = () => (
  <section id="testimonials" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
    <Reveal><Overline>From the gym floor</Overline><SectionTitle className="mt-4">Lifters <span className="text-grad">on Spotter.</span></SectionTitle></Reveal>
    <div className="mt-14 grid gap-5 md:grid-cols-3">
      {QUOTES.map(([q, n, g], i) => (
        <Reveal key={i} delay={i * 0.08}>
          <figure data-testid={`testimonial-${i}`} className={`flex h-full flex-col justify-between rounded-2xl border border-white/[0.08] bg-[#16181f] p-7 ${i === 1 ? "md:translate-y-10" : ""}`}>
            <div className="flex items-center justify-between">
              <Quote className="h-7 w-7 text-[#ff6a3d]" />
              <span data-testid={`testimonial-example-badge-${i}`} className="rounded-full border border-white/15 px-2.5 py-1 font-mono-x text-[10px] uppercase tracking-widest text-[#9ca3af]">Example</span>
            </div>
            <blockquote className="mt-6 text-lg leading-relaxed text-[#e4e6ea]">{q}</blockquote>
            <figcaption className="mt-8 flex items-center gap-3 border-t border-white/10 pt-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-grad font-display text-lg font-black text-[#1a0b05]">{n[0]}</span>
              <span><span className="block font-semibold">{n}</span><span className="text-sm text-[#9ca3af]">{g}</span></span>
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);
